import { Operation } from '../../../__generated__/globalTypes'

import {
  CollectionFragment,
  collectionFragmentString,
} from '../../fragments/__generated__/CollectionFragment'

import { sendableCardImageFragmentString } from '../../fragments/__generated__/SendableCardImageFragment'

import { minimalSendableCardFragmentString } from '../../fragments/__generated__/MinimalSendableCardFragment'

import getCardCollectionsRawString from '../GetCardCollections.graphql'

const getCardCollectionsString = [
  getCardCollectionsRawString,
  collectionFragmentString,
  sendableCardImageFragmentString,
  minimalSendableCardFragmentString,
].join('\n\n')

export type GetCardCollectionsData = {
  collections: CollectionFragment[]
}

export type GetCardCollections = Operation<GetCardCollectionsData>

export const GetCardCollections = (): GetCardCollections => ({
  query: getCardCollectionsString,
  variables: undefined,
})
